import { render, staticRenderFns } from "./CustomerFeedbackHandling.vue?vue&type=template&id=54ca9751&"
import script from "./CustomerFeedbackHandling.vue?vue&type=script&lang=js&"
export * from "./CustomerFeedbackHandling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports